<template>
<div
    class="help_banner"
    v-on:click="onClick"
>
    <div
        style="flex-grow: 1"
    >
        {{label}}
    </div>

    <div
        style="flex-grow: 0"
    >
        <v-icon>
            mdi-help-box-multiple-outline
        </v-icon>
    </div>
</div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: function() { return 'Set label property to change me!'; }
        },

        url: {
            type: String,
            default: function() { return null; }
        },
    },

    methods: {
        onClick() {
            window.open(this.url, '_blank');
        }
    },
}
</script>

<style lang="scss" scoped>
.help_banner
{
    border: 1px solid rgba(0,0,0,0.1); 
    padding-left: 15px; 
    padding-right: 15px; 
    padding-top: 20px; 
    padding-bottom: 20px; 
    border-radius: 5px; 
    margin-bottom: 7px; 
    text-align: left; 
    display: flex; cursor: pointer;
}

.help_banner:hover
{
    text-decoration: underline;
}
</style>